import constate from 'constate';
import type { NavigateFunction } from 'react-router-dom';

export interface PortalNavigationProviderCtxProps {
  navigate: NavigateFunction;
}

function PortalNavigation({ navigate }: PortalNavigationProviderCtxProps) {
  return { navigate };
}

const [PortalNavigationCtx, usePortalNavigationContext] =
  constate(PortalNavigation);

export interface PortalNavigationProviderProps
  extends PortalNavigationProviderCtxProps {
  children: React.ReactNode;
}

const PortalNavigationProvider = ({
  children,
  ...rest
}: PortalNavigationProviderProps) => (
  <PortalNavigationCtx {...rest}>{children}</PortalNavigationCtx>
);

export { PortalNavigationProvider, usePortalNavigationContext };
